export const locale = {
    lang: "ca",
    data: {
        MAP: {
            ShowDisabledDevices: "Mostra dispositius inactius",
        },
    },
};
